import React, { useMemo } from 'react';
import { Card, List, Button, Spin, Empty } from 'antd';
import { FaPlus } from 'react-icons/fa';

const SubjectSelector = ({ subjects, scheduledEntries, onSelectSubject, loading, disabled }) => {
    const unscheduledSubjects = useMemo(() => {
        const scheduledCodes = new Set((scheduledEntries || []).map(e => e.subjectFormField));
        return subjects.filter(s => !scheduledCodes.has(s.subjectCode));
    }, [subjects, scheduledEntries]);

    return (
        <Card title="Available Subjects">
            <Spin spinning={loading}>
                {disabled ? (
                    <Empty description="Select Grade Level and Term to see available subjects." />
                ) : !subjects.length && !loading ? (
                    <Empty description="No subjects found for this criteria." />
                ) : !unscheduledSubjects.length && subjects.length > 0 ? (
                     <Empty description="All available subjects have been scheduled." />
                ) : (
                    <List
                        dataSource={unscheduledSubjects}
                        renderItem={subject => (
                            <List.Item
                                actions={[
                                    <Button
                                        type="primary"
                                        shape="circle"
                                        icon={<FaPlus />}
                                        onClick={() => onSelectSubject(subject)}
                                        disabled={disabled}
                                    />
                                ]}
                            >
                                <List.Item.Meta
                                    title={subject.subjectName}
                                    description={subject.subjectCode}
                                />
                            </List.Item>
                        )}
                        style={{ maxHeight: '60vh', overflowY: 'auto' }}
                    />
                )}
            </Spin>
        </Card>
    );
};

export default SubjectSelector;